import { render, staticRenderFns } from "./CourseEconomyDetailsPage.vue?vue&type=template&id=23a71f9e&scoped=true&"
import script from "./CourseEconomyDetailsPage.vue?vue&type=script&lang=ts&"
export * from "./CourseEconomyDetailsPage.vue?vue&type=script&lang=ts&"
import style0 from "./CourseEconomyDetailsPage.vue?vue&type=style&index=0&id=23a71f9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a71f9e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCol,VIcon,VRow,VTooltip})
